import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { semanticColors } from "../../../utils/colors";
import { typography } from "../../../utils/typography";

const cardSx = {
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
  p: "20px",
  borderRadius: "8px",
  backgroundColor: semanticColors.surface.canvas,
  border: `1px solid ${semanticColors.border.light}`
};

const headerSx = { display: "flex", alignItems: "center", gap: 1 };

const titleSx = {
  ...typography.body.xlBold,
  color: semanticColors.text.primary
};

const validIconSx = {
  color: semanticColors.status.completed,
  fontSize: 20
};

const invalidIconSx = {
  color: semanticColors.status.inProgress,
  fontSize: 20
};

/**
 * One of the requirements a payment configuration has to satisfy before it can
 * be used to charge. Each section carries its own validity, so the professional
 * can see at a glance what is still missing.
 *
 * `valid` is optional: the read-only account section has nothing to satisfy.
 * `title` is optional too, for the single-card layouts (the creation form) where
 * the page heading already says what the card is and a section title would only
 * add noise.
 */
export default function ConfigurationSection({
  title,
  valid,
  children
}: {
  title?: string;
  valid?: boolean;
  children: React.ReactNode;
}) {
  return (
    <Box sx={cardSx}>
      {title && (
        <Box sx={headerSx}>
          {valid !== undefined &&
            (valid ? (
              <CheckCircleIcon sx={validIconSx} />
            ) : (
              <ErrorIcon sx={invalidIconSx} />
            ))}
          <Typography sx={titleSx}>{title}</Typography>
        </Box>
      )}
      {children}
    </Box>
  );
}
